import LegalPage from "./LegalPage";

export default function MentionsLegales() {
  return (
    <LegalPage
      title="Mentions légales"
      subtitle="Conformément aux articles 6-III et 19 de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique (LCEN)."
      lastUpdate="Mai 2026"
      testid="page-mentions-legales"
    >
      <h2>1. Éditeur du site</h2>
      <p>
        Le site <strong>saveursnormandes.fr</strong> est édité par :
      </p>
      <ul>
        <li><strong>Dénomination sociale :</strong> SAVEURS NORMANDES</li>
        <li><strong>Forme juridique :</strong> SASU (société par actions simplifiée unipersonnelle)</li>
        <li><strong>Capital social :</strong> 2 000,00 €</li>
        <li><strong>Siège social :</strong> 4 rue de la Laiterie, 27400 Louviers, France</li>
        <li><strong>SIREN :</strong> 990 061 350</li>
        <li><strong>SIRET (siège) :</strong> 990 061 350 00015</li>
        <li><strong>RCS :</strong> 990 061 350 R.C.S. Évreux (inscrit le 13/08/2025)</li>
        <li><strong>Numéro de TVA intracommunautaire :</strong> FR24990061350</li>
        <li><strong>Code NAF / APE :</strong> 47.29Z (Autres commerces de détail alimentaires en magasin spécialisé)</li>
        <li><strong>Téléphone :</strong> 06 65 02 87 00</li>
        <li><strong>Email :</strong> <a href="mailto:e.awono@saveursnormandes.fr">e.awono@saveursnormandes.fr</a></li>
        <li><strong>Licence d'exploitation :</strong> Licence IV (vente de tous types d'alcools sur place et à emporter)</li>
      </ul>

      <h2>2. Directeur de la publication</h2>
      <p>
        Le directeur de la publication est <strong>M. E. Awono</strong>, en sa qualité de Président de la SASU Saveurs Normandes.
      </p>

      <h2>3. Assurance Responsabilité Civile Professionnelle</h2>
      <p>
        La SASU Saveurs Normandes est titulaire d'un contrat d'assurance Responsabilité Civile Professionnelle couvrant son activité de bar à cocktails, ateliers de mixologie et bar mobile sur le territoire français.
      </p>
      <ul>
        <li><strong>N° de contrat :</strong> 127110027 M - MCE - 001</li>
        <li><strong>Compagnie d'assurance :</strong> BPCE IARD</li>
      </ul>

      <h2>4. Hébergement du site</h2>
      <p>
        Le site est hébergé par <strong>Emergent Labs Inc.</strong>, infrastructure managée Kubernetes, accessible via <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer">emergent.sh</a>. Les boîtes mail associées au domaine sont gérées par <strong>Hostinger International Ltd.</strong> et <strong>Google Workspace</strong>.
      </p>

      <h2>5. Hébergement DNS &amp; domaine</h2>
      <p>
        Le nom de domaine <code>saveursnormandes.fr</code> est enregistré auprès de <strong>Hostinger International Ltd.</strong>, 61 Lordou Vironos Street, 6023 Larnaca, Chypre.
      </p>

      <h2>6. Propriété intellectuelle</h2>
      <p>
        L'ensemble du site (textes, photographies, illustrations, logos, vidéos, charte graphique, code source) est protégé par le droit d'auteur et le droit des marques. Toute reproduction, représentation, modification ou exploitation, totale ou partielle, sans autorisation écrite préalable de Saveurs Normandes est strictement interdite et constitue une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la propriété intellectuelle.
      </p>
      <p>
        Les marques <em>Saveurs Normandes</em>, <em>Bois Sucré Intense</em>, <em>Élixir des Anges</em>, <em>Le Framboisé</em>, <em>Ginga 55</em> ainsi que les visuels de bouteilles sont la propriété exclusive de la SASU Saveurs Normandes.
      </p>

      <h2>7. Responsabilité</h2>
      <p>
        Saveurs Normandes met tout en œuvre pour offrir aux utilisateurs des informations et outils disponibles et vérifiés, mais ne saurait être tenue responsable des erreurs, d'une absence de disponibilité des fonctionnalités ou de la présence de virus sur son site.
      </p>
      <p>
        Les liens hypertextes mis en place dans le cadre du présent site web en direction d'autres ressources présentes sur le réseau Internet ne sauraient engager la responsabilité de Saveurs Normandes.
      </p>

      <h2>8. Données personnelles</h2>
      <p>
        Le traitement des données personnelles est encadré par notre <a href="/confidentialite">Politique de confidentialité</a>, conforme au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés.
      </p>

      <h2>9. Cookies</h2>
      <p>
        Le site utilise uniquement des cookies techniques strictement nécessaires à son fonctionnement (session de connexion sécurisée). Aucun cookie de tracking publicitaire ou statistique tiers n'est déposé sans votre consentement.
      </p>

      <h2>10. Vente d'alcool — Avertissements légaux</h2>
      <p>
        La vente d'alcool aux mineurs de moins de 18 ans est interdite en France (Article L.3342-1 du Code de la santé publique). En commandant sur ce site, le client certifie sur l'honneur être majeur.
      </p>
      <p className="mt-4 p-4 border border-primary/40 bg-primary/5 rounded-lg">
        <strong>L'abus d'alcool est dangereux pour la santé. À consommer avec modération.</strong>
      </p>

      <h2>11. Droit applicable et juridiction compétente</h2>
      <p>
        Les présentes mentions légales sont soumises au droit français. En cas de litige, et après tentative de recherche d'une solution amiable, compétence exclusive est attribuée aux tribunaux français du ressort du Tribunal de Commerce d'Évreux.
      </p>

      <h2>12. Contact</h2>
      <p>
        Pour toute question relative aux présentes mentions légales, vous pouvez nous écrire à : <a href="mailto:e.awono@saveursnormandes.fr">e.awono@saveursnormandes.fr</a>
      </p>
    </LegalPage>
  );
}
